import React from 'react';
import { faCreditCard } from '@fortawesome/pro-solid-svg-icons/faCreditCard';
import { ErrorThumbnail } from '@ukpostbox/frontend-framework';
import { MailItemTopUpRequiredThumbnailType } from '../Types/ThumbnailTypes';

function MailItemTopUpRequiredThumbnail(props: MailItemTopUpRequiredThumbnailType) {
	return <ErrorThumbnail icon={faCreditCard} size={props.size} />;
}

export { MailItemTopUpRequiredThumbnail };
